import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=4168104e&scoped=true"
import script from "./vipList.vue?vue&type=script&lang=js"
export * from "./vipList.vue?vue&type=script&lang=js"
import style0 from "./vipList.vue?vue&type=style&index=0&id=4168104e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168104e",
  null
  
)

export default component.exports